import React from 'react'

import './index.css'

const PrivacyPolicy = () => {
  return (
    <div className="text-start m-5">
      <h2 className="text-center mb-4">Privacy Policy</h2>
      <p>
        When you provide your personal information to Kingsland University, it
        will be used for the administrative or educational purposes of the
        University, in accordance with specific consent given by you, or as
        otherwise allowed under the Privacy Act 1988. The University will not
        make available to a third party any personal information supplied by you
        unless you have consented or the disclosure is otherwise permitted or
        required by law.
      </p>
      <p>
        The University may distribute aggregated statistical information for
        statutory reporting purposes but only in a form that will not identify
        any person individually.
      </p>
      <h4>Digital Logs And Analytics</h4>
      <p>
        As with most websites or other digital properties, when accessing the
        University’s channels, log files are generated by the servers that show
        visitor details such as IP address, date, time and pages visited or
        documents downloaded. Information in these logs may used to generate
        statistical reports about access to University sites.
      </p>
      <h4>Cookie Use</h4>
      <p>
        Kingsland uses digital cookies to deliver you a personalised experience
        on its websites. Cookies are text files saved on your computer’s hard
        drive and used to store small pieces of data.
      </p>
      <p>
        Analytics services, including Google Analytics, use cookies which
        transmit information on your use of the website to a cloud service that
        may not be within your area of use. Google may also transfer this
        information to third parties where required by law, or where such third
        parties process the information on Google’s behalf. Kingsland uses
        Google Analytics and other analytics services for the purpose of
        evaluating online activity and improving your personalised experience
        online.
      </p>
      <p>
        By using this website or other University digital channels, you consent
        to the processing of data about you by Google in the manner and for the
        purposes set out above. You may refuse the use of cookies by selecting
        the appropriate settings on your browser; however, please note if you do
        this you may not be able to use the full functionality of this website
        or receive a personalised experience.
      </p>
      <h4>Secure Socket Layer (SSL) Encryption</h4>
      <p>
        Certain University websites may use SSL encryption to provide a more
        secure method of transferring personal information such as passwords or
        contact details.
      </p>
      <h4>Opting Out Of Communications</h4>
      <p>
        Kingsland University ensures when sending out direct marketing
        communication that you are able to opt out of future communications.
        There are links provided in such communication enabling you to
        unsubscribe or to email the sender to request your details be removed.
        On social media channels, each platform provides guidelines on how to
        opt out of future communications, in accordance with their relevant
        privacy statements.
      </p>
      <h4>Social Media</h4>
      <p>
        The University website may also employ Facebook Insights. This provides
        aggregated, non-personally identifiable information to page owners and
        platform developers. For more information about privacy on Facebook,
        refer to the Facebook privacy page.
      </p>
      <h4>Re-targeting Advertising</h4>
      <p>
        Kingsland may use re-targeting advertising to deliver more appropriate
        content or advertisements to individuals or audiences who have
        previously visited one of its websites. Google, Facebook and other
        advertising companies may use digital cookies from your browser and
        serve you advertisements from the University.
      </p>
      <h4>Public Forums</h4>
      <p>
        The University may employ chat rooms or message boards that form a
        component of a University website or online learning system. Some
        systems may enable other users to share your posted information and you
        should exercise caution when disclosing personal information.
      </p>
      <h4>Copyright Notice</h4>
      <p>
        Kingsland University claims copyright ownership of all information
        stored on its websites, unless expressly stated otherwise.
      </p>
      <p>
        Moral rights reside with the author, unless expressly stated otherwise.
        Contact the author in the first instance if you wish to copy, use or
        link to a particular page or article.
      </p>
      <h4>Disclaimer</h4>
      <p>
        Kingsland strives to keep information stored on its website, social
        channels and other digital services up to date, but cannot guarantee the
        information provided is accurate, current or reliable. The information
        is provided ‘as is’ with no express or implied warranty. Any mistakes in
        the information that are brought to our attention will be corrected as
        soon as possible.
      </p>
      <p>
        The University reserves the right to make changes to any material on its
        digital channels at any time including, but not limited to, details
        relating to courses, admissions, fees and services.
      </p>
      <p>
        Web links from this site to external, non-University websites should not
        be construed as implying any commercial or other relationship with
        and/or endorsement of the external site or its content by Kingsland
        University, and you are advised to inform yourself as to the privacy
        statement of those external websites.
      </p>
      <h3 className="mt-5 mb-3">Google User Data</h3>
      <p>
        The Google{' '}
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </p>
      <h4 className="fw-bold">Access</h4>
      <p>
        Kingsland University accesses your profile including Google ID, name,
        email, Google Classrooms courses related to Kingsland University. Your
        profile information is for display purposes only and is not stored in
        our servers.
      </p>
      <h4 className="fw-bold">Uses</h4>
      <p>
        Kingsland University uses Google Classroom to retrieve the class
        recordings in the platform using the courses you are enrolled.
      </p>
      <h4 className="fw-bold">Storage</h4>
      <p>
        Kingsland University merely acts as a middleman to retrieve the
        associated class recordings in the platform using the courses you are
        enrolled in. The platform does not store any information from your
        Google account.
      </p>
      <h4 className="fw-bold">Sharing</h4>
      <p>
        Kingsland University will never share any information that can be
        retrieved from your Google Account to third-party providers.
      </p>
    </div>
  )
}

export default PrivacyPolicy
